var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8487 35.8487C35.1101 36.5859 34.1092 37 33.0657 37C32.0221 37 31.0212 36.5859 30.2827 35.8487L20.0512 25.5455L9.92193 35.6952C9.18339 36.4324 8.18249 36.8465 7.13895 36.8465C6.0954 36.8465 5.0945 36.4324 4.35597 35.6952C3.61871 34.9567 3.20463 33.9558 3.20463 32.9122C3.20463 31.8687 3.61871 30.8678 4.35597 30.1292L14.5057 20L4.15134 9.7173C3.41408 8.97876 3 7.97786 3 6.93432C3 5.89077 3.41408 4.88987 4.15134 4.15134C4.88987 3.41408 5.89077 3 6.93432 3C7.97786 3 8.97876 3.41408 9.7173 4.15134L20 14.4647L30.1292 4.31504C30.8678 3.57778 31.8687 3.1637 32.9122 3.1637C33.9558 3.1637 34.9567 3.57778 35.6952 4.31504C36.4324 5.05358 36.8465 6.05448 36.8465 7.09802C36.8465 8.14156 36.4324 9.14247 35.6952 9.881L25.5455 20.0102L35.8487 30.2827C36.5859 31.0212 37 32.0221 37 33.0657C37 34.1092 36.5859 35.1101 35.8487 35.8487Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiply);
export default __webpack_public_path__ + "static/media/multiply.49e3d97a7ae6250b1508aec6c041fe21.svg";
export { ForwardRef as ReactComponent };